import { Component } from '@angular/core';
import { conversations, messages } from '../ai-chat.data';
import { Router } from '@angular/router';
import { AIChatService, AIChatSession } from '../../../services/ai-chat';

@Component({
  selector: 'app-ai-chat-screen',
  templateUrl: './ai-chat-screen.component.html',
  styleUrls: ['./ai-chat-screen.component.scss'],
})
export class AIChatScreenComponent {
  filter: any = {};

  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;

  error = false;
  success = false;

  pending: boolean = false;
  loading: boolean = false;

  fullScreenMode: boolean = false;
  continueScrolling: boolean = true;

  conversations: any[] = conversations;
  selectedConversation;
  aiConversationSession: AIChatSession | undefined;
  aggregateCount = this.conversations.length;

  privateId: boolean = false;

  searchFilter = {
    groupOp: 'OR',
    rules: [],
  };
  headerFilters: any[];
  headers: any[];

  sessionId: string | undefined;
  selectedsessionId: string | undefined;

  constructor(private router: Router, private aiChatService: AIChatService) {}

  loadConversationView(item, i) {
    console.log(item);
    this.selectedsessionId = item.sessionId;
    this.selectedConversation = item;
    this.router.navigate(['/contractor/ai-chat/screen/ai-user-chat'], {
      queryParams: {
        id: item.sessionId,
      },
    });
  }

  getChatData() {
    const url = new URL(window.location.href);
    this.sessionId = url.searchParams.get('id');
    if (this.sessionId) {
      this.selectedConversation = messages.find(
        (msg) => msg.sessionId === this.sessionId
      );
    }
  }

  initiateChatSession() {
    console.log('initiate chat session');
    this.pending = true;
    this.aiChatService.getChatSession().subscribe(
      (data) => {
        console.log(data);
        // this.newConversation = data;
        this.pending = false;
        this.success = true;
      },
      (error) => {
        this.error = true;
        this.pending = false;
      }
    );
  }

  ngOnInit(): void {
    this.getChatData();
  }
}
